import { YEAR_RECAP_ROUTE_NAME, YEAR_RECAP_ROUTE_PATH } from './constants'

export default [
  {
    path: YEAR_RECAP_ROUTE_PATH,
    name: YEAR_RECAP_ROUTE_NAME,
    meta: { title: 'Your year on AhaSlides' },
    component: () => import('./YearRecapPage.vue'),
  },
]
